import {Logic} from '../Type'

export class API extends Logic.Type {
    public SelectedView:'addKey'|'manageKeys'='addKey'
    public keys:any
    public SelectedApps:string=''
    public entityKeys:string[]
    public keyName:string
}